import * as React from 'react';

const SvgHome = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.12}
      d="M1.95703 7.03995C1.95703 6.65705 1.95703 6.46559 2.00533 6.28928C2.0481 6.1331 2.11841 5.98621 2.21278 5.85582C2.31932 5.70862 2.46721 5.59108 2.76298 5.356L7.18762 1.83925C7.41682 1.65708 7.53142 1.566 7.65796 1.53098C7.76962 1.50009 7.8873 1.50009 7.99896 1.53098C8.1255 1.566 8.2401 1.65708 8.4693 1.83925L12.8939 5.356C13.1897 5.59108 13.3376 5.70862 13.4441 5.85582C13.5385 5.98621 13.6088 6.1331 13.6516 6.28928C13.6999 6.46559 13.6999 6.65705 13.6999 7.03995V11.8632C13.6999 12.61 13.6999 12.9833 13.5577 13.2686C13.4326 13.5194 13.233 13.7234 12.9875 13.8512C12.7084 13.9966 12.343 13.9966 11.6123 13.9966H4.04465C3.31391 13.9966 2.94855 13.9966 2.66944 13.8512C2.42394 13.7234 2.22433 13.5194 2.09924 13.2686C1.95703 12.9833 1.95703 12.61 1.95703 11.8632V7.03995Z"
      fill="#0E0C0F"
    />
    <path
      d="M5.21894 11.3299H10.438M7.18762 1.83925L2.76298 5.356C2.46721 5.59108 2.31932 5.70862 2.21278 5.85582C2.11841 5.98621 2.0481 6.1331 2.00533 6.28928C1.95703 6.46559 1.95703 6.65705 1.95703 7.03995V11.8632C1.95703 12.61 1.95703 12.9833 2.09924 13.2686C2.22433 13.5194 2.42394 13.7234 2.66944 13.8512C2.94855 13.9966 3.31391 13.9966 4.04465 13.9966H11.6123C12.343 13.9966 12.7084 13.9966 12.9875 13.8512C13.233 13.7234 13.4326 13.5194 13.5577 13.2686C13.6999 12.9833 13.6999 12.61 13.6999 11.8632V7.03995C13.6999 6.65705 13.6999 6.46559 13.6516 6.28928C13.6088 6.1331 13.5385 5.98621 13.4441 5.85582C13.3376 5.70862 13.1897 5.59108 12.8939 5.356L8.4693 1.83925C8.2401 1.65708 8.1255 1.566 7.99896 1.53098C7.8873 1.50009 7.76962 1.50009 7.65796 1.53098C7.53142 1.566 7.41682 1.65708 7.18762 1.83925Z"
      stroke="#0E0C0F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgHome;
